<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <a-card title="Listar Categoria de Atendimento">
    <div class="row" style="margin-bottom: 1%">
      <div class="col-md-9">
        <label for="nome">Descrição</label>
        <div class="input-group input-focus">
          <input type="text" class="form-control form-input-component" v-model="nome" ref="nome" />
        </div>
      </div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div class="col-md-4" style="margin-bottom: 0.3%">
        <button @click="pesquisar()" class="btn btn-primary" type="button"><i class="fa fa-search"> </i> Pesquisar</button>
        <button type="button" class="btn btn-primary" @click="criarNova" style="margin: 0 5px">
          <i class="fa fa-plus"> </i>
          Criar novo
        </button>
      </div>
    </div>
  </a-card>
  <br />
  <a-card>
    <a-table :dataSource="lista" :columns="columns" :pagination="paginationConfig">
      <template #situacao="{ record }">
        <a-switch :checked="record.situacao === 'ATIVO'" @change="toggleSituacao(record)" />
      </template>
      <template #action="{ record }">
        <a title="Excluir" @click="excluir(record)"><i class="fas fa-trash icon-trash"></i></a>
        &nbsp;&nbsp;
        <a title="Editar" @click="editar(record)"><i class="fas fa-edit icon-edit"></i></a>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { deleteById, getLista } from '@/components/service/categoria-atendimento';

export default {
  name: 'PageListarCategoriaAtendimento',
  data() {
    return {
      situacao: 'TODOS',
      nome: undefined,
      lista: [],
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      columns: [
        {
          title: 'Descrição',
          dataIndex: 'descricao',
          key: 'descricao',
          slots: { customRender: 'descrição' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    excluir(record) {
      deleteById(record.id)
        .then(() => {
          openNotification(typesNotification.success, 'Excluído com sucesso.');
          this.pesquisar();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao excluir!');
        });
    },
    editar(record) {
      this.$router.push({ path: '/form-categoria-atendimento', query: { id: record.id } });
    },
    criarNova() {
      this.$router.push('form-categoria-atendimento');
    },

    async pesquisar() {
      var filtros = { descricao: this.descricao };
      getLista(filtros)
        .then((r) => {
          if (r.data.length > 0) {
            this.lista = r.data;
          } else {
            openNotification(typesNotification.info, 'Nenhum registro encontrado para os dados informados na pesquisa!');
            this.lista = r.data;
          }
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a listagem de cadastrados!');
        });
    },
  },
  created() {
    this.pesquisar();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
